<nav class="navbar navbar-expand-lg navbar-light fixed-top " *ngIf="loggeduser">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img src="./assets/img/board_logo.png" height="50px" width="50px">
      </a>
      <button id="navbarbtn" class="navbar-toggler navbtn navbarbtn" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse navmob justify-content-end" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <!-- student Menu -->
          <li class="nav-item">
            <a  class="nav-link" href=""  [routerLink]="['/dashboard']">Home</a>
          </li>
              <!-- <li class="nav-item" >
                <a  class="nav-link" href="" [routerLink]="['/myprofile']">View My Profile</a>
              </li> -->
            <!-- <li class="nav-item" >
            <a  class="nav-link" href="" [routerLink]="['/applynewmigration']">Apply New Migration Certificate</a>
                      </li>-->
          <li class="nav-item dropdown" *ngIf="isstudent" >
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Apply For </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" *ngIf="isfreshmigration" [routerLink]="['/applynewmigration']"> Fresh Migration Requests</a></li>
              <li><a class="dropdown-item" *ngIf="isnamechagemarsheet" [routerLink]="['/applynamechange']"> Changes On marksheet</a></li>
              <li><a class="dropdown-item" *ngIf="isnamechagepassingcert" [routerLink]="['/applynamechange']"> Changes on Passing Certificate</a></li>
              <li><a class="dropdown-item" *ngIf="isduplimigration" [routerLink]="['/applyduplicatemigration']"> Duplicate Migration Certificate</a></li>
              <li><a class="dropdown-item" *ngIf="isduplicatepassingcertificate" [routerLink]="['/applyduplicatemarsksheet']"> Duplicate Passing Certificate</a></li>
              <li><a class="dropdown-item" *ngIf="isduplicatemarsheet" [routerLink]="['/applyduplicatemarsksheet']"> Duplicate Marksheet</a></li>
            </ul>
          </li>
          <li class="nav-item" *ngIf="isstudent">
            <a  class="nav-link" href=""  [routerLink]="['/viewapplicationstatus']">View Application status</a>
          </li>
          <!--end student Menu -->

          <!-- boardadmin Menu -->
          <li class="nav-item dropdown" *ngIf="isboardadmin || isboardcord">
              <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Migration Requests </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" [routerLink]="['/viewallmigrationrequest']">Fresh Migration Certificate Requests</a></li>
                <!-- <li><a class="dropdown-item disabled-link">Duplicate Migration Certificate Requests </a></li> -->
                <!-- <li><a class="dropdown-item" [routerLink]="['/generatemigrationcertificate']">Generate Migration Certificate</a></li> -->
              </ul>
          </li>
          <li class="nav-item dropdown" *ngIf="isboardadmin || isboardcord">
              <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Other Requests </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li><a class="dropdown-item" [routerLink]="['/viewrequest','duplicatepassingcertificate']">Duplicate Passing Certificate Requests </a></li>
                <li><a class="dropdown-item " [routerLink]="['/viewrequest','duplicatemarksheet']">Duplicate Marksheet Requests </a></li>
                <li><a class="dropdown-item " [routerLink]="['/viewrequest','changemarksheet']">Change On Marksheet</a></li>
                <li><a class="dropdown-item " [routerLink]="['/viewrequest','changepassingcertificate']">Change On Passing Certificate</a></li>
              </ul>
          </li>
          <!-- <li class="nav-item" *ngIf="isboardadmin">
            <a  class="nav-link" href="" [routerLink]="['/updaterequeststatus']">Update Request Status</a>
          </li> -->
          <!-- <li class="nav-item dropdown" *ngIf="isboardadmin || isboardcord">
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
             Update Requests Status </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['/updaterequeststatus']">Fresh Migration Requests</a></li>
              <li><a class="dropdown-item disabled-link" [routerLink]="['/updaterequeststatus']">Change In Name Requests</a></li>
              <li><a class="dropdown-item disabled-link">Duplicate Passing Certificate Requests </a></li>
              <li><a class="dropdown-item disabled-link">Duplicate Marksheet Requests </a></li>
            </ul>
        </li> -->
        <li class="nav-item">
          <a  class="nav-link" href="" *ngIf="isboardadmin || isboardcord"  [routerLink]="['/updaterequeststatus']">Update Request Status</a>
        </li>
          <li class="nav-item dropdown" *ngIf="isboardadmin" >
            <a class="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Configurations </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li><a class="dropdown-item" [routerLink]="['/updatefees']"> Fees Update</a></li>
              <li><a class="dropdown-item"  [routerLink]="['/addboarduser']"> Add Board user </a></li>
            </ul>
          </li>
          <!--end  boardadmin Menu -->
          <li class="nav-item"  *ngIf="loggeduser">
            <a  class="nav-link" style="font-size: 1.5rem; margin-top: -0.4rem;" (click)="logout()"><i class="bi bi-box-arrow-right"></i></a>
          </li>
          
        
        </ul>
       
      </div>
    </div>
  </nav>
<div class="betweenWrapper">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
